import { useContext } from "react";

import { Heading, Icon } from "@icg360/design-system";

import { MultiStepFormLayout } from "components/multi-step-form-layout";
import { AuthAppContext } from "components/root/auth-app-provider";
import { useMultiStepFormState } from "hooks/use-multi-step-form-state";
import {
  WindDefenseContext,
  type WindDefenseContextState,
} from "pages/offer/wind-defense/wind-defense-flow";
import { formatTwoLineAddress } from "utils";

import styles from "./shingle-reseal.module.scss";

export const PolicyConfirmation = () => {
  const { policy } = useContext(AuthAppContext);
  const { formNavigate } =
    useMultiStepFormState<WindDefenseContextState>(WindDefenseContext);

  if (!policy.propertyAddress) {
    return null;
  }

  const { lineOne, lineTwo } = formatTwoLineAddress(
    policy.propertyAddress,
    true
  );

  return (
    <MultiStepFormLayout
      step={1}
      totalSteps={5}
      heading="Confirm your address"
      subheading="This service is available only for the property associated with your policy."
      buttonProps={{
        primary: { path: "../contact-information" },
        cancel: { path: "/my/property-services/wind-defense" },
        promptOnCancel: true,
        formNavigate,
      }}
    >
      <div className={styles.iconItem}>
        <div className={styles.iconDS}>
          <Icon name="Home" size="lg" />
        </div>
        <div>
          <Heading size="sm">{lineOne}</Heading>
          <Heading size="sm">{lineTwo}</Heading>
          <div className={styles.subtext}>Policy number: {policy.policyId}</div>
        </div>
      </div>
    </MultiStepFormLayout>
  );
};
